import { render, staticRenderFns } from "./PanelEmpresa.view.vue?vue&type=template&id=2616bb45&scoped=true"
import script from "./PanelEmpresa.view.vue?vue&type=script&lang=js"
export * from "./PanelEmpresa.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2616bb45",
  null
  
)

export default component.exports